import {lazy} from 'react';

export const PageNotFoundAsync = lazy(() =>
    import('./PageNotFound')
);
